<template>
  <el-dialog title="客诉详情" :visible.sync="formVisible" width="1100px" :close-on-click-modal="false" custom-class="complaint-detail-dialog">
    <el-row :gutter="16" v-loading="loading">
      <!-- 左侧：客户信息 + 反馈内容 + 处理记录 -->
      <el-col :span="16">
        <div class="block-title">自动读取客户信息</div>
        <el-form :model="detail" label-width="90px" size="small" class="readonly-form">
          <el-row :gutter="10">
            <el-col :span="8">
              <el-form-item label="客户姓名">
                <el-input :value="detail.customerName" readonly />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="电话">
                <el-input :value="detail.customerPhone" readonly suffix-icon="el-icon-lock" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="地址">
                <el-input :value="fullAddress" readonly suffix-icon="el-icon-lock" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="8">
              <el-form-item label="对应业务老师">
                <el-input :value="detail.businessUserName" readonly />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="对应技术老师">
                <el-input :value="detail.techUserName" readonly />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="身份">
                <el-input :value="detail.identityName" readonly />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>

        <div class="block-title mt10">反馈内容</div>
        <div class="content-box">
          <div class="content-line">
            <span class="content-label">反馈类型</span>
            <el-tag size="mini">{{detail.typeName}}</el-tag>
          </div>
          <div class="content-line">
            <span class="content-label">问题描述</span>
            <span class="content-text">{{detail.content}}</span>
          </div>
          <div class="content-line" v-if="imageList.length">
            <span class="content-label">图片附件</span>
            <span>
              <el-image v-for="(img, index) in imageList" :key="index" class="content-image" :src="img" :preview-src-list="imageList" fit="cover" />
            </span>
          </div>
        </div>

        <div class="block-title mt10">处理记录</div>
        <el-timeline v-if="recordList.length" class="record-timeline">
          <el-timeline-item v-for="(item, index) in recordList" :key="index" type="primary" :timestamp="item.createdTime" placement="top">
            <div class="record-line">
              <el-tag size="mini" type="info" v-if="+item.recordType === 3">内部备注</el-tag>
              <el-tag size="mini" type="success" v-else-if="+item.recordType === 2">回复客户</el-tag>
              <span class="record-text">{{item.content}}</span>
            </div>
            <!-- 备注/回复里上传的图片。原来这里只渲染文字，图片存进去了但一张都不显示 -->
            <div class="record-images" v-if="recordImages(item).length">
              <el-image
                v-for="(img, imgIndex) in recordImages(item)"
                :key="imgIndex"
                class="content-image"
                :src="img"
                :preview-src-list="recordImages(item)"
                fit="cover" />
            </div>
            <div class="record-operator" v-if="item.operatorName">操作人：{{item.operatorName}}</div>
          </el-timeline-item>
        </el-timeline>
        <div class="empty-tip" v-else>暂无处理记录</div>
      </el-col>

      <!-- 右侧：处理操作 -->
      <el-col :span="8">
        <div class="block-title">处理操作</div>
        <el-form ref="dataForm" :model="form" :rules="formRules" label-width="90px" size="small">
          <!-- 用户 2026-09-10：处理负责人**固定为当前登录账号，不给选**。
               谁点的处理就是谁负责，避免把单子指给别人后没人跟进。
               这里只做展示，真正落库的 handlerId 在 doHandle/doFinish 提交时统一取当前账号（见下）。 -->
          <el-form-item label="处理负责人">
            <el-input :value="currentHandlerName" readonly suffix-icon="el-icon-lock" />
          </el-form-item>
          <el-form-item label="处理状态" prop="state">
            <el-select v-model="form.state" placeholder="请选择处理状态" :disabled="archived">
              <!-- BUG-2026-208846：options 给**全集**、用 disabled 控制哪些能选，
                   不要把「已归档」从 options 里滤掉 —— el-select 找不到对应 option 就直接把
                   原始 value 显示出来，已归档记录的处理状态会渲染成数字 5。
                   「过滤可选项」和「回显已有值」共用同一份 options 时，只能靠 disabled 区分。 -->
              <el-option v-for="item in COMPLAINT_STATE_LIST" :key="item.value" :label="item.label" :value="item.value" :disabled="item.value === STATE_ARCHIVED"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="处理意见" prop="handleOpinion">
            <el-input type="textarea" :rows="5" maxlength="500" show-word-limit v-model="form.handleOpinion" placeholder="请输入处理意见（客户可见）" :disabled="archived" />
          </el-form-item>
          <el-form-item label="内部备注" prop="innerRemark">
            <el-input type="textarea" :rows="5" maxlength="500" show-word-limit v-model="form.innerRemark" placeholder="请输入内部备注（仅内部可见）" :disabled="archived" />
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" size="small" :disabled="archived" @click="doHandle()" v-hasPermi="['complaint:feedback:reply']">保存处理</el-button>
      <el-button type="primary" size="small" :disabled="archived" @click="doFinish()" v-hasPermi="['complaint:feedback:reply']">完成处理</el-button>
      <el-button size="small" :disabled="archived" @click="doArchive()" v-hasPermi="['complaint:feedback:archive']">归档</el-button>
      <el-button size="small" @click="formVisible = false">关闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
import customerComplaintApi from '@/api/complaint/customerComplaint'
import { COMPLAINT_STATE_LIST, STATE_ARCHIVED, STATE_FINISHED } from '../complaintState'

function initFormBean() {
  return {
    id: null,
    handlerId: null,
    state: null,
    handleOpinion: null,
    innerRemark: null
  }
}

export default {
  name: 'ComplaintHandle',
  data() {
    return {
      COMPLAINT_STATE_LIST,
      // 模板里 :disabled 要用它（BUG-2026-208846）。import 进来的常量不放进 data
      // 模板就取不到，:disabled 会恒为 undefined —— 归档项照样可选，而且不报错。
      STATE_ARCHIVED,
      formVisible: false,
      loading: false,
      isRepSub: false,
      detail: {},
      recordList: [],
      form: initFormBean(),
      formRules: {
        state: [{ required: true, message: '请选择处理状态', trigger: 'change' }]
      }
    }
  },
  computed: {
    archived() {
      return +this.detail.state === STATE_ARCHIVED
    },
    // 「已归档」不进处理状态下拉：归档只能走底部【归档】按钮，
    // 后端 handle 接口收到 state=5 会直接抛「归档请走【归档】按钮」。
    /**
     * BUG-2026-208846 之后不再用它做 options（会让已归档回显成数字 5），
     * 保留是因为别处可能引用；「哪些状态可选」现在由 el-option 上的 disabled 表达。
     */
    selectableStateList() {
      return COMPLAINT_STATE_LIST.filter(item => item.value !== STATE_ARCHIVED)
    },
    fullAddress() {
      const d = this.detail
      return [d.addrProvince, d.addrCity, d.addrArea, d.addrDetail].filter(v => !!v).join('')
    },
    /**
     * 处理负责人显示名：**当前登录账号**。
     *
     * 已归档的单子是只读的，这时显示**原来那条记录上的负责人**才对 —— 归档后再打开
     * 不能让它显示成"当前查看的人"，那是篡改历史。所以归档态优先取 detail 上的名字。
     */
    currentHandlerName() {
      if (this.archived) {
        return this.detail.handlerName || this.detail.handlerRealName || this.$store.getters.name || '-'
      }
      return this.$store.getters.name || '-'
    },
    imageList() {
      if (!this.detail.images) return []
      return String(this.detail.images).split(',').filter(v => !!v)
    }
  },
  methods: {
    /**
     * 一条处理记录里的图片。
     *
     * 后端 CustomerComplaintRecordVO 同时给了 imageList(数组) 和 images(逗号串)，
     * 两个都兜住：优先用数组，没有再按详情区那套老办法拆逗号串。
     * 不是过度防御 —— 下面取 recordList 时已经在兼容
     * recordList / records / recordVOList 三种外壳，字段名同样不能只赌一种。
     *
     * 数据链路是通的（insert 存 images、select 查 images、toRecordVO 转 imageList），
     * 「图片没显示」纯粹是这个页面从来没写渲染，不是没存上。
     */
    recordImages(item) {
      if (!item) return []
      if (Array.isArray(item.imageList)) return item.imageList.filter(v => !!v)
      if (!item.images) return []
      return String(item.images).split(',').map(v => v.trim()).filter(v => !!v)
    },
    handleDetail(row) {
      this.detail = {}
      this.recordList = []
      this.form = initFormBean()
      this.form.id = row.id
      this.formVisible = true
      this.loadDetail(row.id)
    },
    loadDetail(id) {
      this.loading = true
      return customerComplaintApi.fetchById(id)
        .then(data => {
          const d = (data && data.data) || {}
          this.detail = d
          this.recordList = d.recordList || d.records || d.recordVOList || []
          this.form.id = d.id || id
          this.form.handlerId = d.handlerId || null
          this.form.state = d.state || null
          this.form.handleOpinion = d.handleOpinion || null
          this.form.innerRemark = null
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 处理负责人改成固定当前账号后，这里原来那个「拉 1000 条内部员工」的请求也一并删了 ——
    // 打开每条客诉详情都发一次、结果没人再用。要恢复选择功能的话连同 el-select 一起还原。
    submit(params) {
      if (this.isRepSub) return
      this.isRepSub = true
      return customerComplaintApi.handle(params)
        .then(() => {
          this.$message.success('操作成功')
          this.formVisible = false
          this.$emit('created')
        })
        .finally(() => {
          this.isRepSub = false
        })
    },
    /**
     * 保存处理：按右侧选中的状态提交
     */
    doHandle() {
      this.$refs['dataForm'].validate(valid => {
        if (!valid) return
        this.submit({ ...this.form, handlerId: this.$store.getters.userId })
      })
    },
    /**
     * 完成处理：直接置为【已完成】
     */
    doFinish() {
      this.submit({ ...this.form, state: STATE_FINISHED, handlerId: this.$store.getters.userId })
    },
    doArchive() {
      return this.$common.confirm('归档后不能再回复或添加备注，是否确认归档？')
        .then(() => customerComplaintApi.archive({ id: this.form.id }))
        .then(() => {
          this.$message.success('归档成功')
          this.formVisible = false
          this.$emit('created')
        })
        .catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
.block-title {
  color: #409eff;
  font-size: 14px;
  font-weight: 600;
  padding-bottom: 8px;
  border-bottom: 1px solid #ebeef5;
  margin-bottom: 10px;
}
.readonly-form ::v-deep .el-form-item {
  margin-bottom: 10px;
}
.content-box {
  background: #f7f9fc;
  border-radius: 4px;
  padding: 12px;
}
.content-line {
  display: flex;
  margin-bottom: 10px;
  &:last-child {
    margin-bottom: 0;
  }
}
.content-label {
  width: 70px;
  flex-shrink: 0;
  color: #8f8e8e;
  font-size: 13px;
}
.content-text {
  font-size: 13px;
  color: #303133;
  line-height: 20px;
}
.content-image {
  width: 46px;
  height: 46px;
  border-radius: 4px;
  margin-right: 8px;
}
.record-timeline {
  max-height: 240px;
  overflow-y: auto;
  padding-left: 4px;
}
.record-line {
  font-size: 13px;
  color: #303133;
}
.record-text {
  margin-left: 4px;
}
.record-images {
  margin-top: 6px;
}
.record-operator {
  font-size: 12px;
  color: #8f8e8e;
  margin-top: 4px;
}
.empty-tip {
  font-size: 13px;
  color: #8f8e8e;
  padding: 10px 0;
}
::v-deep .el-select {
  width: 100%;
}
</style>
